
import React from 'react';
import { CalendarDays, User, Briefcase } from 'lucide-react';
import { Teacher } from '@/types/teacher.types';

interface TeacherAboutTabProps {
  teacher: Teacher;
}

export const TeacherAboutTab = ({ teacher }: TeacherAboutTabProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl font-semibold mb-3">Subjects & Expertise</h3>
        {teacher.subjects && teacher.subjects.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {teacher.subjects.map((subject: string, index: number) => (
              <span 
                key={index} 
                className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm"
              >
                {subject}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-gray-500">No subjects assigned</p>
        )}
      </div>

      <div>
        <h3 className="text-xl font-semibold mb-3">Biography</h3>
        <p className="text-gray-700">
          {teacher.bio || 'No biography provided.'}
        </p>
      </div>
      
      <div>
        <h3 className="text-xl font-semibold mb-3">Personal Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-center">
            <CalendarDays className="w-5 h-5 text-gray-500 mr-2" />
            <span>Age: {teacher.age || 'Not provided'}</span>
          </div>
          <div className="flex items-center">
            <CalendarDays className="w-5 h-5 text-gray-500 mr-2" />
            <span>DOB: {teacher.dateOfBirth ? new Date(teacher.dateOfBirth).toLocaleDateString() : 'Not provided'}</span>
          </div>
          <div className="flex items-center">
            <User className="w-5 h-5 text-gray-500 mr-2" />
            <span>Marital Status: {teacher.maritalStatus || 'Not provided'}</span>
          </div>
          <div className="flex items-center">
            <Briefcase className="w-5 h-5 text-gray-500 mr-2" />
            <span>Employment Type: {teacher.employmentType || 'Not provided'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
